var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommityValueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.9501C16.7533 18.9834 11.3867 16.2067 5.41333 15.1334C2.59 14.6434 0 16.8834 0 19.7534V34.3134C0 38.2334 1.68 40.2867 3.99 40.5901C9.82333 41.3367 15.12 43.7401 19.46 47.2867C20.2767 47.9634 21.6067 48.0334 22.4233 47.3801C26.7867 43.8101 32.13 41.3601 38.01 40.6134C40.2033 40.3101 42 38.1401 42 35.9001V19.7534C42 16.8834 39.41 14.6434 36.5867 15.1334C30.6133 16.2067 25.2467 18.9834 21 22.9501ZM21 14.6667C24.8733 14.6667 28 11.5401 28 7.66675C28 3.79341 24.8733 0.666748 21 0.666748C17.1267 0.666748 14 3.79341 14 7.66675C14 11.5401 17.1267 14.6667 21 14.6667Z",
    fill: "#007ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommityValueIcon);
export default __webpack_public_path__ + "static/media/CommityValueIcon.7ed3d11ae11fa759162ddab85e55c0b2.svg";
export { ForwardRef as ReactComponent };